const BASE_REWARD_AMOUNT = 1_000;

export const DEFAULT_REFERRAL_REWARD_TIERS: Record<number, number> = {
    1: 1_000,
    2: 2_000,
    5: 6_000,
};

export const calculateRewardBalance = (
    numberOfFriends: number,
    tiers: Record<number, number> = DEFAULT_REFERRAL_REWARD_TIERS
): string => {
    const baseAmount = tiers[1] ?? BASE_REWARD_AMOUNT;
    const amount = tiers[numberOfFriends] ?? baseAmount * numberOfFriends;
    return `$${amount.toLocaleString()}`;
};
